<template>
    <div v-if="!isPc && isShowBtn" class="fix-top">
      <a @click="close">
        <img
          class="close_btn"
          :src="require(`@img/btn_close.png`)"
        />
      </a>
    </div>
  </template>
  
  <script setup>
  import { ref } from "vue";
  import cocosUtil from '@/assets/js/cocosUtil'

  let isPc = ref(false)
  let isShowBtn = ref(false)

  const ua = navigator.userAgent.toLowerCase()
  const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mac|/i.test(ua)
  if(!isMobile) {
    isPc = true
  }
  
  const close = () => {
    cocosUtil.sendMsg({
      type: 'close',
      status: true
    })
  }
  const showSaveImage = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const inkkwebview = urlParams.get("inkkwebview")

    isShowBtn.value = inkkwebview === 'true' ? true : false
  }
  showSaveImage()
  </script>
  <style lang="scss" scoped>
  .fix-top {
    position: fixed;
    left: fixedRight(10);
    top: 10px;
    z-index: 10;
  
    @media (max-width: $containerWidth) {
      left: 10px;
    }
  }
  
  .close_btn {
    width: 70px;
    @media (max-width: $containerWidth) {
      width: pxToVw(70px);
    }
  
    // &.closeBtn_open {
    //   animation: zoom-in-zoom-out 1s ease infinite;
    // }
  }
  
  </style>
  